import * as React from 'react'
import { cn } from '@/lib/utils'

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?:
    | 'default'
    | 'secondary'
    | 'destructive'
    | 'outline'
    | 'success'
    | 'warning'
    | 'info'
    | 'escalated'
}

function Badge({ className, variant = 'default', ...props }: BadgeProps) {
  return (
    <div
      className={cn(
        'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
        {
          'border-transparent bg-primary text-primary-foreground hover:bg-primary/80':
            variant === 'default',
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80':
            variant === 'secondary',
          'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80':
            variant === 'destructive',
          'text-foreground': variant === 'outline',
          'border-transparent bg-success text-success-foreground hover:bg-success/80':
            variant === 'success',
          'border-transparent bg-warning text-warning-foreground hover:bg-warning/80':
            variant === 'warning',
          'border-transparent bg-info text-info-foreground hover:bg-info/80': variant === 'info',
          // Escalated → Plum (#6D2E6E, brand palette) fill + white text; arbitrary
          // Tailwind value since there is no plum design token.
          'border-transparent bg-[#6D2E6E] text-white hover:bg-[#6D2E6E]/90':
            variant === 'escalated',
        },
        className
      )}
      {...props}
    />
  )
}

export { Badge }
